import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function LinkedInIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM8.00198 9.56028V19.2222H5.00347V9.56028H8.00198ZM8.22768 6.49043C8.22768 7.45986 7.45387 8.26771 6.48661 8.26771C5.55159 8.26771 4.77778 7.45986 4.77778 6.49043C4.77778 5.55332 5.55159 4.77778 6.48661 4.77778C7.45387 4.77778 8.22768 5.55332 8.22768 6.49043ZM19.2222 19.2222H19.19H16.2237V14.5367C16.2237 13.4057 16.1915 11.9838 14.6438 11.9838C13.0962 11.9838 12.8705 13.1795 12.8705 14.4397V19.2222H9.87202V9.56028H12.7416V10.8852H12.7738C13.193 10.1419 14.1602 9.33408 15.6111 9.33408C18.6419 9.33408 19.2222 11.3376 19.2222 13.9227V19.2222Z" />
    </IconWrapper>
  );
}
